"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Container = _interopRequireDefault(require("../Container"));

var _Title = _interopRequireDefault(require("../Title"));

var _Text = _interopRequireDefault(require("../Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _priorityBaggage = _interopRequireDefault(require("./priorityBaggage.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var PriorityBaggageWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriorityBaggage__PriorityBaggageWrapper",
  componentId: "sc-1ebukw7-0"
})(["display:flex;flex-direction:column;"]);

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriorityBaggage__ContentWrapper",
  componentId: "sc-1ebukw7-1"
})(["border-bottom:", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "1px solid ".concat(theme.colors.greyLight);
}, function (_ref2) {
  var theme = _ref2.theme,
      isMobile = _ref2.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.XSmall) : " ".concat(theme.space.small, " ").concat(theme.space.semi, " ").concat(theme.space.small, " ").concat(theme.space.small);
});

var HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriorityBaggage__HeaderWrapper",
  componentId: "sc-1ebukw7-2"
})(["display:grid;grid-template-columns:", ";"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '100%' : '75% 25%';
});

var InfoWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriorityBaggage__InfoWrapper",
  componentId: "sc-1ebukw7-3"
})([""]);

var AmountWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriorityBaggage__AmountWrapper",
  componentId: "sc-1ebukw7-4"
})(["display:", ";text-align-last:", ";*:last-child{padding-left:", ";}"], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 'flex' : 'block';
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 'left' : 'right';
}, function (_ref6) {
  var theme = _ref6.theme,
      isMobile = _ref6.isMobile;
  return isMobile ? "".concat(theme.space.tiny) : "0";
});

var ItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriorityBaggage__ItemWrapper",
  componentId: "sc-1ebukw7-5"
})(["border-bottom:", ";cursor:pointer;display:flex;justify-content:space-between;padding:", ";&:last-child{border-bottom:none;}"], function (_ref7) {
  var theme = _ref7.theme;
  return "1px solid ".concat(theme.colors.greyLight);
}, function (_ref8) {
  var theme = _ref8.theme,
      isMobile = _ref8.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.XSmall) : "".concat(theme.space.small, " ").concat(theme.space.semi, " ").concat(theme.space.small, " ").concat(theme.space.small);
});

var PriorityBaggage = function PriorityBaggage(props) {
  var accessible = props.accessible,
      theme = props.theme,
      priorityBaggageData = props.priorityBaggageData,
      isMobile = props.isMobile,
      currencyCode = props.currencyCode,
      selectedPriorityBaggage = props.selectedPriorityBaggage,
      onSelectPriorityBaggage = props.onSelectPriorityBaggage,
      translation = props.translation;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var handleSelectPriorityBaggage = function handleSelectPriorityBaggage(baggage, route) {
    var isDeselect = selectedPriorityBaggage[route] && selectedPriorityBaggage[route].id === baggage.id;

    var newSelectedPriorityBaggage = _objectSpread(_objectSpread({}, selectedPriorityBaggage), (0, _defineProperty2.default)({}, route, isDeselect ? {} : baggage));

    onSelectPriorityBaggage(newSelectedPriorityBaggage);
  };

  var getAddButton = function getAddButton(isSelected) {
    return isSelected ? /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      bold: true,
      color: "tertiary",
      display: "inlineFlex",
      hasToggle: false,
      opacity: 1,
      tag: "p",
      theme: theme,
      translation: {},
      type: "sub"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: "tertiary",
      fontsize: "default",
      icon: "CheckIcon",
      theme: theme
    }), language.added) : /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      bold: true,
      color: "secondary",
      display: "inlineFlex",
      hasToggle: false,
      opacity: 1,
      tag: "p",
      theme: theme,
      translation: {},
      type: "sub"
    }, language.add);
  };

  var getDisplayLabel = function getDisplayLabel(label) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      display: "inlineFlex",
      hasToggle: false,
      opacity: 1,
      tag: "p",
      theme: theme,
      translation: {},
      type: "sub"
    }, label);
  };

  var getPriorityBaggages = function getPriorityBaggages() {
    // eslint-disable-next-line react/prop-types
    var departFlight = priorityBaggageData.departFlight,
        returnFlight = priorityBaggageData.returnFlight; // eslint-disable-next-line react/prop-types

    var selectedDepartFlight = selectedPriorityBaggage.departFlight,
        selectedReturnFlight = selectedPriorityBaggage.returnFlight;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, departFlight && Object.keys(departFlight).length > 0 && /*#__PURE__*/_react.default.createElement(ItemWrapper, {
      isMobile: isMobile,
      onClick: function onClick() {
        return (// eslint-disable-next-line react/prop-types
          handleSelectPriorityBaggage(departFlight, 'departFlight')
        );
      }
    }, getDisplayLabel(language.departureFlight), getAddButton( // eslint-disable-next-line react/prop-types
    selectedDepartFlight && selectedDepartFlight.id === departFlight.id)), returnFlight && Object.keys(returnFlight).length > 0 && /*#__PURE__*/_react.default.createElement(ItemWrapper, {
      isMobile: isMobile,
      onClick: function onClick() {
        return (// eslint-disable-next-line react/prop-types
          handleSelectPriorityBaggage(returnFlight, 'returnFlight')
        );
      }
    }, getDisplayLabel(language.returnFlight), getAddButton( // eslint-disable-next-line react/prop-types
    selectedReturnFlight && selectedReturnFlight.id === returnFlight.id)));
  };

  var getAmount = function getAmount() {
    var _priorityBaggageData$;

    var displayedAmount = priorityBaggageData.departFlight.amount > 0 ? priorityBaggageData.departFlight.amount : (_priorityBaggageData$ = priorityBaggageData.returnFlight.amount) !== null && _priorityBaggageData$ !== void 0 ? _priorityBaggageData$ : 0;
    return "".concat(currencyCode, " ").concat(displayedAmount);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PriorityBaggageWrapper, {
      tabIndex: tabIndex,
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Container.default, {
      accessible: accessible,
      alignChildren: "start",
      focusEffect: false,
      gapChildren: "none",
      hasBoxShadow: false,
      hoverEffect: false,
      isSideBySide: false,
      layout: 2,
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(ContentWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(InfoWrapper, null, /*#__PURE__*/_react.default.createElement(_Title.default, {
      accessible: accessible,
      inverted: false,
      textAlign: "left",
      theme: theme,
      color: _constant.TITLE_COLOR,
      type: "h4"
    }, language.priorityBaggageTitle), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      color: "greyDark",
      display: "inlineFlex",
      hasToggle: false,
      opacity: 1,
      tag: "p",
      theme: theme,
      translation: {},
      type: isMobile ? 'sub' : 'small',
      verticalAlign: "center"
    }, language.priorityBaggageNote)), /*#__PURE__*/_react.default.createElement(AmountWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Title.default, {
      accessible: accessible,
      inverted: false,
      textAlign: "left",
      theme: theme,
      type: "h4"
    }, getAmount()), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      color: "greyDark",
      display: "inlineFlex",
      hasToggle: false,
      opacity: 1,
      tag: "p",
      theme: theme,
      translation: {},
      type: isMobile ? 'sub' : 'small',
      verticalAlign: "center"
    }, language.priorityBaggageUnit)))), getPriorityBaggages()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PriorityBaggage.propTypes = _priorityBaggage.default.PropTypes;
PriorityBaggage.defaultProps = _priorityBaggage.default.DefaultProps;
var _default = PriorityBaggage;
exports.default = _default;